import React from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'
import { useLanguageStore } from '../../zustand/language/use-language-store'

export const LanguageProvider = ({ children }) => {
  const { locale, messages } = useLanguageStore()

  return (
    <IntlProvider locale={locale} messages={messages}>
      {React.Children.only(children)}
    </IntlProvider>
  )
}

LanguageProvider.propTypes = {
  children: PropTypes.element.isRequired
}

export default LanguageProvider
